import React, { Component } from "react";
import ReactDOM from "react-dom";
import "react-bootstrap";

import * as apiConstant from "../../api/apiConstant";
import $ from "jquery/dist/jquery.js";
import store from "../../store/configureStore";
import Empty from "../../components/NoData";
import SingleSlider from "../../components/SingleSlider";
import { Link } from "react-router-dom";
import { lang } from "../../config/lang";
import { connect } from "react-redux";
import { addNotification } from "../../actions/notificationAction";
import { changeTopBannerAction } from "../../actions/topBannerAction";
import { changeActiveItemAction } from "../../actions/navAction";
import { Businesses, PagesForCaption, CaptionCodes } from "../../config/Helper";
import captionApi from "../../api/captionApi";
import activityApi from "../../api/activityApi";
import * as UTILS from "../../config/utils";
import logApi from "../../api/logApi";
/****************************************
    Component for activity detail page
    @author  UYM
    @date    2020.05.13
    @version 0.1    
 ******************************************/

class ActivityDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: this.props.match.params.id,
      business: "",
      title: "",
      description: "",
      arrImage: [],
      otherItemsCap: "",
      arrOtherActivities: [],
      exception: true,
      style: 0,
    };

    this.bSwitcherByLang = false;
    this.init = this.init.bind(this);
    this.hidePreloader = this.hidePreloader.bind(this);
  }

  componentWillMount() {
    this.init(this.state.id);
    store.dispatch(changeActiveItemAction(Businesses.indexOf("activity")));
    store.dispatch(
      changeTopBannerAction({
        page: "",
        showSearch: false,
        isHome: false,
      })
    );
  }

  componentDidMount() {
    // const sideBlogs = store.getState().activity.items;
    // console.log(store.getState())
    // const arrOtherItem = sideBlogs.filter(item => { return item.id != this.state.id })
    // console.log(arrOtherItem)
    // this.setState({
    //     ...this.state,
    //     arrOtherActivities: arrOtherItem
    // })
    this.showFooter(false);
    window.onSetClass("dark");
    window.playVideo();
  }

  componentWillUnmount() {}

  componentWillUpdate() {}

  componentDidUpdate() {
    window.scrollTop("#root");
  }

  componentWillReceiveProps(newProps) {
    if (this.state.id === newProps.match.params.id) this.bSwitcherByLang = true;
    else this.bSwitcherByLang = false;

    if (this.state.business !== undefined && this.state.business !== "") {
      if (!this.bSwitcherByLang) {
        ReactDOM.unmountComponentAtNode(document.getElementById("blog_slider"));
        // ReactDOM.findDOMNode(this.refs.preloader).style.visibility = "visible";
      }

      this.init(newProps.match.params.id);
    }
  }
  showFooter(willShow) {
    $("#footer").css("visibility", willShow ? "visible" : "hidden");
  }
  showPreloader() {
    if (this.refs.preloader) {
      ReactDOM.findDOMNode(this.refs.preloader).style.visibility = "visible";
    }
  }
  hidePreloader() {
    if (this.refs.preloader) {
      ReactDOM.findDOMNode(this.refs.preloader).style.visibility = "hidden";
    }
    // ReactDOM.findDOMNode(this.refs.preloader).style.visibility = "hidden";
    // $('#single_slider').css("visibility", "visible");
    this.showFooter(true);
  }

  async init(id) {
    var arrOtherItem = [];
    var otherItemsCap = "";
    if (!this.bSwitcherByLang) {
      this.showPreloader();
    }
    activityApi.getSideBlogs(id).then((json) => {
      if (json.status === 200 && json.data) {
        arrOtherItem = json.data;
      } else {
        if (json.status === 620) {
          store.dispatch(addNotification(`${lang("access_deny")}`, "error"));
        } else {
        }
      }
    });
    // const sideBlogs = store.getState().activity.items;
    // console.log(store.getState())
    // arrOtherItem = sideBlogs.filter(item => { return item.id != id })
    captionApi.getCaptions("activity_detail").then((json) => {
      if (json.status === 200) {
        otherItemsCap =
          json.data[
            CaptionCodes[PagesForCaption.indexOf("activity_detail")].indexOf(
              "activity_other_activities"
            )
          ];
      } else {
        store.dispatch(addNotification(`${lang("server_err")}`, "error"));
      }
    });
    activityApi.getFind(id).then((json) => {
      if (json.status === 200 && json.data) {
        this.setState({
          id: id,
          business: json.data.business,
          title: json.data.title,
          description: json.data.description,
          style: json.data.style,
          arrImage: json.data.media,
          otherItemsCap:
            otherItemsCap === undefined ||
            otherItemsCap.title === undefined ||
            otherItemsCap.title === null
              ? ""
              : otherItemsCap.title,
          arrOtherActivities: arrOtherItem,
          exception: true,
        });
        // if (!this.bSwitcherByLang) {
        ReactDOM.render(
          <SingleSlider
            media={this.state.arrImage}
            business={this.state.business}
            id={this.state.id}
            title={this.state.title}
          />,
          document.getElementById("blog_slider")
        );
        $("#single_slider").css("visibility", "visible");
        setTimeout(this.hidePreloader, 800);
        // }
        $("#footer").css("visibility", "visible");
      } else {
        this.setState({
          exception: false,
        });
        if (json.status === 620) {
          store.dispatch(addNotification(`${lang("access_deny")}`, "error"));
        } else {
        }
      }
    });
  }

  render() {
    if (!this.state.exception) {
      return (
        <section
          className="ftco-section ftco-animate fadeIn ftco-animated empty"
          id="tourist-activity-section"
        >
          <Empty />
        </section>
      );
    }
    if (this.state.style === 0) {
      return (
        <div className="ftco-revolution-section bg-light">
          <section
            className="ftco-services-2 ftco-animate fadeIn ftco-animated"
            id="tourist-activity-section"
          >
            <hr className="solid tall" />
            <div className="container" id="breadcrumb">
              <div className="row">
                <div className="col-md-12">
                  <div className="portfolio-title">
                    <div className="row">
                      <div className="col-md-12 heading-section">
                        <h2
                          className="mb-none mt-2 figure fadeIn animated"
                          data-animate="fadeIn"
                          style={{
                            textIndent:
                              localStorage.getItem("language") === "cn"
                                ? "21.25pt"
                                : "14.5pt",
                          }}
                          dangerouslySetInnerHTML={{ __html: this.state.title }}
                        ></h2>
                        <div
                          className="figure pull-right fadeIn animated"
                          data-animate="fadeIn"
                        >
                          <a
                            href="/activity"
                            title={lang("pager_back")}
                            className="portfolio-nav-all breadcrumb-item"
                          >
                            <div
                              className="mb-none"
                              dangerouslySetInnerHTML={{
                                __html: lang("activity"),
                              }}
                            ></div>
                          </a>
                          <span className="portfolio-nav-all breadcrumb-item">
                            <div
                              className="mb-none"
                              dangerouslySetInnerHTML={{
                                __html: this.state.title,
                              }}
                            ></div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-lg-8 pr-lg-4">
                  <div>
                    <div className="blog" id="blog_slider"></div>
                    <div className="preloader" id="preloader" ref="preloader">
                      <div className="spinner"></div>
                    </div>
                  </div>
                  <div
                    className="description ftco-animate fadeInUp ftco-animated"
                    dangerouslySetInnerHTML={{ __html: this.state.description }}
                  ></div>
                </div>
                <div className="col-lg-4 p-4 recent-place">
                  <div className="row">
                    <div className="col-md-11 ml-auto">
                      <div className="side-box">
                        <h2 className="heading">{this.state.otherItemsCap}</h2>
                        <ul className="post-list list-unstyled">
                          {this.state.arrOtherActivities.map((item, key) => (
                            <OtherActivities
                              key={key}
                              business={this.state.business}
                              id={item.id}
                              title={item.title}
                              image={item.media_filename}
                              mediaType={item.media_filetype}
                            />
                          ))}
                          <li>
                            <a
                              href="/activity"
                              className="btn btn-primary btn-outline-primary"
                            >
                              {lang("view_all")}
                              <i className="ion-ios-arrow-forward"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      );
    } else if (this.state.style === 1) {
      return (
        <div className="ftco-section bg-light">
          <section
            className="ftco-services-2 ftco-animate fadeIn ftco-animated"
            id="tourist-activity-section"
          >
            <hr className="solid tall" />
            <div className="container" id="breadcrumb">
              <div className="row">
                <div className="col-md-12">
                  <div className="portfolio-title">
                    <div className="row">
                      <div className="col-md-12 heading-section">
                        <h2
                          className="mb-none mt-2 figure fadeIn animated"
                          data-animate="fadeIn"
                          style={{
                            textIndent:
                              localStorage.getItem("language") === "cn"
                                ? "21.25pt"
                                : "14.5pt",
                          }}
                          dangerouslySetInnerHTML={{ __html: this.state.title }}
                        ></h2>
                        <div
                          className="figure pull-right fadeIn animated"
                          data-animate="fadeIn"
                        >
                          <a
                            href="/activity"
                            title={lang("pager_back")}
                            className="portfolio-nav-all breadcrumb-item"
                          >
                            <div
                              className="mb-none"
                              dangerouslySetInnerHTML={{
                                __html: lang("activity"),
                              }}
                            ></div>
                          </a>
                          <span className="portfolio-nav-all breadcrumb-item">
                            <div
                              className="mb-none"
                              dangerouslySetInnerHTML={{
                                __html: this.state.title,
                              }}
                            ></div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-lg-8 pr-lg-4">
                  <div
                    className="description ftco-animate fadeInUp ftco-animated"
                    dangerouslySetInnerHTML={{ __html: this.state.description }}
                  ></div>
                  <div className="mt-5">
                    <div className="blog" id="blog_slider"></div>
                    <div className="preloader" id="preloader" ref="preloader">
                      <div className="spinner"></div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 p-4 recent-place">
                  <div className="row">
                    <div className="col-md-11 ml-auto">
                      <div className="side-box">
                        <h2 className="heading">{this.state.otherItemsCap}</h2>
                        <ul className="post-list list-unstyled">
                          {this.state.arrOtherActivities.map((item, key) => (
                            <OtherActivities
                              key={key}
                              business={this.state.business}
                              id={item.id}
                              title={item.title}
                              image={item.media_filename}
                              mediaType={item.media_filetype}
                            />
                          ))}
                          <li>
                            <a
                              href="/activity"
                              className="btn btn-primary btn-outline-primary"
                            >
                              {lang("view_all")}
                              <i className="ion-ios-arrow-forward"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      );
    } else {
      return (
        <div className="ftco-section bg-light">
          <section
            className="ftco-services-2 ftco-animate fadeIn ftco-animated"
            id="tourist-activity-section"
          >
            <hr className="solid tall" />
            <div className="container" id="breadcrumb">
              <div className="row">
                <div className="col-md-12">
                  <div className="portfolio-title">
                    <div className="row">
                      <div className="col-md-12 heading-section">
                        <div
                          className="figure pull-right fadeIn animated"
                          data-animate="fadeIn"
                        >
                          <a
                            href="/activity"
                            title={lang("pager_back")}
                            className="portfolio-nav-all breadcrumb-item"
                          >
                            <div
                              className="mb-none"
                              dangerouslySetInnerHTML={{
                                __html: lang("activity"),
                              }}
                            ></div>
                          </a>
                          <span className="portfolio-nav-all breadcrumb-item">
                            <div
                              className="mb-none"
                              dangerouslySetInnerHTML={{
                                __html: this.state.title,
                              }}
                            ></div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-lg-8 pr-lg-4">
                  <div>
                    <div className="blog" id="blog_slider"></div>
                    <div className="preloader" id="preloader" ref="preloader">
                      <div className="spinner"></div>
                    </div>
                  </div>
                  <div className="col-md-12 heading-section mb-5">
                    <h2
                      className="mb-none mt-2 figure fadeIn animated"
                      data-animate="fadeIn"
                      style={{
                        textIndent:
                          localStorage.getItem("language") === "cn"
                            ? "21.25pt"
                            : "14.5pt",
                      }}
                      dangerouslySetInnerHTML={{ __html: this.state.title }}
                    ></h2>
                  </div>
                  <div
                    className="description ftco-animate fadeInUp ftco-animated"
                    dangerouslySetInnerHTML={{ __html: this.state.description }}
                  ></div>
                </div>
                <div className="col-lg-4 p-4 recent-place">
                  <div className="row">
                    <div className="col-md-11 ml-auto">
                      <div className="side-box">
                        <h2 className="heading">{this.state.otherItemsCap}</h2>
                        <ul className="post-list list-unstyled">
                          {this.state.arrOtherActivities.map((item, key) => (
                            <OtherActivities
                              key={key}
                              business={this.state.business}
                              id={item.id}
                              title={item.title}
                              image={item.media_filename}
                              mediaType={item.media_filetype}
                            />
                          ))}
                          <li>
                            <a
                              href="/activity"
                              className="btn btn-primary btn-outline-primary"
                            >
                              {lang("view_all")}
                              <i className="ion-ios-arrow-forward"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      );
    }
  }
}

class OtherActivities extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.waitAndEllipsis = this.waitAndEllipsis.bind(this);
    this.ellipsisStyle = this.ellipsisStyle.bind(this);
  }
  componentDidMount() {
    setTimeout(this.ellipsisStyle, 600);
    window.addEventListener("resize", this.waitAndEllipsis);
  }

  componentDidUpdate() {
    setTimeout(this.ellipsisStyle, 600);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.waitAndEllipsis);
  }

  waitAndEllipsis() {
    setTimeout(this.ellipsisStyle, 800);
  }

  ellipsisStyle() {
    window.ellipsisMe("#activity_detail_" + this.props.id);
  }

  onErrorLoadImage(e) {
    $(e.target).attr("src", "/assets/images/no_image.png");
  }

  render() {
    return (
      <li className="ftco-animate fadeIn ftco-animated">
        <div className="blog side-block d-flex-flex">
          <div className="d-flex-flex">
            <Link to={`/activity/${this.props.id}`}>
              {(this.props.image === undefined ||
                this.props.image === null) && (
                <img
                  className="side-img mr-3"
                  src="/assets/images/no_image.png"
                  alt="activity"
                />
              )}
              {this.props.image !== undefined && this.props.image !== null && (
                <img
                  className="side-img mr-3"
                  src={apiConstant.thumbnail(
                    this.props.business,
                    this.props.id,
                    this.props.image.split(".")[0] + ".jpg"
                  )}
                  onError={(e) => this.onErrorLoadImage(e)}
                  alt="activity"
                />
              )}
            </Link>
            {this.props.image !== undefined &&
              this.props.image !== null &&
              this.props.mediaType === 1 && (
                <a
                  href={apiConstant.desktop(
                    this.props.business,
                    this.props.id,
                    this.props.image
                  )}
                  onError={(e) => this.onErrorLoadImage(e)}
                  className="play-video video-icon small"
                  onClick={() =>
                    logApi.log({
                      title: this.props.title,
                      lang: localStorage.getItem("language"),
                      type: "동화상",
                    })
                  }
                >
                  <i className="fa fa-play" aria-hidden="true"></i>
                </a>
              )}
          </div>
          <div className="text mt-2">
            <Link to={`/activity/${this.props.id}`}>
              <h3
                className="ellipsis multiline post-title"
                id={`activity_detail_${this.props.id}`}
                caption={this.props.title}
                dangerouslySetInnerHTML={{
                  __html:
                    this.props.title === undefined || this.props.title === null
                      ? ""
                      : this.props.title,
                }}
              />
            </Link>
          </div>
        </div>
      </li>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps)(ActivityDetail);
